import { Checkbox as PrimeCheckbox } from "primereact/checkbox";

import type { CheckboxViewProps } from "./types-checkbox";

export function CheckboxView({ checkboxRef, checkboxProps }: CheckboxViewProps) {
  return <PrimeCheckbox ref={checkboxRef} {...checkboxProps} />;
}
